import { useEffect } from 'react';

import { offersApi } from '@Modules/offers/api';

const VIEW_DELAY_MS = 3000;

export const useOfferViewTracking = (offerId: number | undefined): void => {
  useEffect(() => {
    if (!offerId) {
      return undefined;
    }

    const timer = setTimeout(() => {
      offersApi.postOfferView({ offerId }).catch(() => {});
    }, VIEW_DELAY_MS);

    return () => clearTimeout(timer);
  }, [offerId]);
};
